import * as React from "react";

import fbIcon from "../../../../assets/images/fb.png";
import firebase from "firebase";
import SocialSignInButtonWithLogo from "../../../../components/buttons/SocialSignInButtonWithLogo";
import { Icon } from "@iconify/react";

export interface GoogleSignInProps {
  handleCreateCustomToken: any;
  backColour: any;
  backText: any;
}

/* Google sign in page */
const FacebookSignIn: React.FunctionComponent<GoogleSignInProps> = ({
  handleCreateCustomToken,
  backColour,
  backText,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = () => {
    setIsLoading(true);
    const provider = new firebase.auth.FacebookAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result: any) => {
        if (result && result.user) {
          firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
              firebaseUser.getIdToken(true).then(async function (idToken) {
                handleCreateCustomToken(idToken);
              });
            }
          });
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const { email } = error;
        // The firebase.auth.AuthCredential type that was used.
        const { credential } = error;
        setIsLoading(false);
      });
  };

  return (
    <SocialSignInButtonWithLogo
      handleClick={handleClick}
      isLoading={isLoading}
      backColour={backColour}
      logoSrc={
        <Icon
          icon="ic:baseline-facebook"
          style={{
            width: "32px",
            minWidth: "32px",
            height: "32px",
          }}
          color={backText}
        />
      }
      isFullWidth={true}
      labelText="Sign in with Facebook"
      backText={backText}
    />
  );
};

export default FacebookSignIn;
